import { Box, Icon } from "@chakra-ui/react";
import { MdLock } from "react-icons/md";

// Auth Imports
import SignIn from "views/auth/signIn/SignIn";
import SignUp from "views/auth/signup";
import SignUpBusiness from "views/auth/signup-business";
import VerifyEmailBusiness from "views/auth/signup-business";
import {
  IconCustomers,
  IconDashboard,
  IconRewards,
  IconServices,
  IconSupport,
  IconTeam,
  IconUnfollowedUser,
  ProfileIcon,
} from "components/icons/Icons";

import Teams from "views/admin/teams";
import Customers from "views/admin/customers";
import Projects from "views/admin/projects";
import TranslatorProjects from "views/translator/projects";
import ManagerProjects from "views/manager/projects";
import OrderIndex from "views/customer/order_old";
import CustomerProjects from "views/customer/projects";
import CustomerProjectDetail from "views/customer/project-detail";
import Services from "views/customer/services";
import Rewards from "views/customer/rewards";
import Support from "views/customer/support";
import OrderCompletedPage from "views/customer/order/page/OrderCompletedPage";
import Forgot from "views/auth/forgot";
import Reset from "views/auth/reset";
import UnfinishedUsers from "views/admin/unfinishedUsers";
import SetPassword from "views/auth/set";
import BusinessProfile from "views/auth/business";
import AdminDashboard from "views/admin/dashboard";
import CustomerDashboard from "views/customer/dashboard";
import ManagerDashboard from "views/manager/dashboard";
import AccountDetailsPage from "views/customer/profile/pages/AccountDetailsPage";
import AdminSupportTopics from "views/admin/support/SupportTopics";
import AdminSupportChat from "views/admin/support/SupportChat";
import SupportSidebarIcon from "assets/img/layout/support.svg";
// import RevenueDashboard from "views/admin/dashboard/revenue";

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "/dashboard",
    icon: <IconDashboard h="25px" w="24px" />,
    component: AdminDashboard,
  },
  // {
  //   name: "Revenue Dashboard",
  //   layout: "/admin",
  //   path: "/revenue/dashboard",
  //   icon: <IconDashboard h="25px" w="24px" />,
  //   component: RevenueDashboard,
  // },
  {
    name: "Team",
    layout: "/admin",
    path: "/team",
    icon: <IconTeam h="25px" w="24px" />,
    component: Teams,
  },
  {
    name: "Projects",
    layout: "/admin",
    path: "/projects",
    icon: <IconTeam h="25px" w="24px" />,
    component: Projects,
  },
  {
    name: "Customers",
    layout: "/admin",
    path: "/customers",
    icon: <IconCustomers h="25px" w="24px" />,
    component: Customers,
  },
  {
    name: "Unfinished Users",
    layout: "/admin",
    path: "/unfinished-users",
    icon: <IconUnfollowedUser h="23px" w="24px" />,
    component: UnfinishedUsers,
  },
  {
    name: "Support",
    layout: "/admin",
    path: "/support",
    icon: <Box as="img" src={SupportSidebarIcon} h="25px" w="24px" />,
    component: AdminSupportTopics,
  },
  {
    name: "SupportChat",
    layout: "/admin",
    path: "/support/:chatId",
    hidden: true,
    icon: <Box as="img" src={SupportSidebarIcon} h="25px" w="24px" />,
    component: AdminSupportChat,
  },

  {
    name: "Sign In",
    layout: "/auth",
    path: "/sign-in",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: SignIn,
  },
  {
    name: "Verify",
    layout: "/auth",
    path: "/verify",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: VerifyEmailBusiness,
  },
  {
    name: "Forgot",
    layout: "/auth",
    path: "/forgot/",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: Forgot,
  },
  {
    name: "Forgot",
    layout: "/auth",
    path: "/reset-password/",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: Reset,
  },
  {
    name: "BusinessProfile",
    layout: "/auth",
    path: "/create-profile/",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: BusinessProfile,
  },
  {
    name: "Set",
    layout: "/auth",
    path: "/set-password/",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: SetPassword,
  },
  {
    name: "Sign Up",
    layout: "/auth",
    path: "/sign-up",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: SignUp,
  },
  {
    name: "Sign Up Business",
    layout: "/auth",
    path: "/sign-up-business",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: SignUpBusiness,
  },
  {
    name: "Projects",
    layout: "/translator",
    path: "/projects",
    icon: <IconTeam h="25px" w="24px" />,
    component: TranslatorProjects,
  },
  // Translator Router
  {
    name: "Dashboard",
    layout: "/manager",
    path: "/dashboard",
    icon: <IconDashboard h="25px" w="24px" />,
    component: ManagerDashboard,
  },
  {
    name: "Projects",
    layout: "/manager",
    path: "/projects",
    icon: <IconTeam h="25px" w="24px" />,
    component: ManagerProjects,
  },
  {
    name: "Services",
    layout: "/manager",
    path: "/services",
    icon: <IconServices h="25px" w="24px" />,
    component: Services,
  },
  {
    name: "Support",
    layout: "/manager",
    path: "/support",
    icon: <Box as="img" src={SupportSidebarIcon} h="25px" w="24px" />,
    component: AdminSupportTopics,
  },
  {
    name: "SupportChat",
    layout: "/manager",
    path: "/support/:chatId",
    hidden: true,
    icon: <Box as="img" src={SupportSidebarIcon} h="25px" w="24px" />,
    component: AdminSupportChat,
  },
  // Customers Router
  {
    name: "Dashboard",
    layout: "/customer",
    path: "/dashboard",
    icon: <IconDashboard h="25px" w="24px" />,
    component: CustomerDashboard,
  },
  {
    name: "Dashboard",
    layout: "/customer",
    path: "/main",
    hidden: true,
    icon: <IconDashboard h="25px" w="24px" />,
    component: OrderIndex,
  },
  {
    name: "MainOrder",
    layout: "/customer",
    path: "/main/:orderId",
    hidden: true,
    icon: <IconDashboard h="25px" w="24px" />,
    component: OrderIndex,
  },
  {
    name: "Projects",
    layout: "/customer",
    path: "/projects",
    icon: <IconTeam h="25px" w="24px" />,
    component: CustomerProjects,
  },
  {
    name: "Services",
    layout: "/customer",
    path: "/services",
    icon: <IconServices h="25px" w="24px" />,
    component: Services,
  },
  {
    name: "Rewards",
    layout: "/customer",
    path: "/rewards",
    icon: <IconRewards h="25px" w="24px" />,
    component: Rewards,
  },
  {
    name: "Support",
    layout: "/customer",
    path: "/support",
    icon: <IconSupport h="25px" w="24px" />,
    component: Support,
  },
  {
    name: "Orders",
    layout: "/customer",
    path: "/order/:orderId",
    icon: <IconRewards h="25px" w="24px" />,
    component: OrderIndex,
    hidden: true,
  },
  {
    name: "OrdersCompleted",
    layout: "/customer",
    path: "/order/completed/:orderId",
    icon: <IconRewards h="25px" w="24px" />,
    component: OrderCompletedPage,
    hidden: true,
  },
  {
    name: "ProjectDetail",
    layout: "/customer",
    path: "/project/:id",
    icon: <IconRewards h="25px" w="24px" />,
    component: CustomerProjectDetail,
    hidden: true,
  },
  {
    name: "Settings",
    layout: "/customer",
    path: "/account-details",
    icon: <ProfileIcon h="25px" w="24px" />,
    component: AccountDetailsPage,
  },
];

export default routes;
